import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

interface AttestationHeaderProps {
    attestationName: string,
    isVisible: boolean
}

const AttestationHeader = (props: AttestationHeaderProps): ReactElement | null => {
    const { attestationName, isVisible } = props;

    const dataTestId = `ssap-attestation-header-${attestationName}`;
    const textId = `ssap.sign_and_review.subheader.${attestationName}`;

    if(!isVisible) {
        return null;
    }

    return (
        <h5 data-testid = { dataTestId } className = 'required-true margin-bottom-1em' >
            <FormattedMessage id = { textId } />
        </h5>
    );
};

export default AttestationHeader;